import {useEffect} from "react";
import {useParams} from "react-router";
import isNull from "../../../../../mixin/isNull";
import {CircularProgress} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import useWorkRepository from "../../../../../repository/user/useWorkRepository";
import useOrderRepository from "../../../../../repository/insurance/useOrderRepository";
import useClientRepository from "../../../../../repository/insurance/useClientRepository";
import useSuggestionRepository from "../../../../../repository/assignment/useSuggestionRepository";
import Map from "./Map";

export default function () {
    const {token} = useParams();
    const suggestionRepository = useSuggestionRepository();
    const orderRepository = useOrderRepository();
    const clientRepository = useClientRepository();
    const workRepository = useWorkRepository();
    /** @type Suggestion */
    const suggestion = suggestionRepository.findOneByToken(token).select();
    /** @type Order */
    const order = orderRepository.findOneById(suggestion?.getInsuranceOrderId()).select();
    /** @type Client */
    const client = clientRepository.findOneById(order?.getClientId()).select();
    /** @type Work */
    const work = workRepository.findOneById(order?.getWorkId()).select();

    useEffect(() => {
        if (isNull(suggestion)) return;

        orderRepository.findOneById(suggestion.getInsuranceOrderId()).exec();
    }, [JSON.stringify(suggestion)]);

    useEffect(() => {
        if (isNull(order)) return;

        clientRepository.findOneById(order.getClientId()).exec();
        workRepository.findOneById(order.getWorkId()).exec();
    }, [JSON.stringify(order)]);

    if (isNull(order) || isNull(client) || isNull(suggestion)) {
        return (
            <Box display="flex" justifyContent={"center"} mt={5}>
                <CircularProgress/>
            </Box>
        )
    }

    return (
        <Box>
            <Typography
                mb={2}
                textAlign={"center"}
                textTransform={"uppercase"}
                fontSize={"small"}
            >
                {client.getCity()} ({client.getPostcode()}) : {work?.getName() ?? "loading..."}
            </Typography>
            <Typography
                mt={2}
                fontSize={"small"}
            >
                {order.getDescription()}
            </Typography>
            <Box mt={2}>
                <Map clientId={order.getClientId()}/>
            </Box>
        </Box>
    )
}
